var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M13 3.5H4C3.17157 3.5 2.5 4.17157 2.5 5V12C2.5 12.8284 3.17157 13.5 4 13.5H13C13.8284 13.5 14.5 12.8284 14.5 12V5C14.5 4.17157 13.8284 3.5 13 3.5Z",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M6.25 9H10.75C11.4404 9 12 9.55964 12 10.25V10.25C12 10.9404 11.4404 11.5 10.75 11.5H6.25C5.55964 11.5 5 10.9404 5 10.25V10.25C5 9.55964 5.55964 9 6.25 9Z",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M9.75 9V11.5",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M7.25 9V11.5",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.5 3.5V1",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M5.75 7.5C6.16421 7.5 6.5 7.16421 6.5 6.75C6.5 6.33579 6.16421 6 5.75 6C5.33579 6 5 6.33579 5 6.75C5 7.16421 5.33579 7.5 5.75 7.5Z",
          fill: "currentColor",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M11.25 7.5C11.6642 7.5 12 7.16421 12 6.75C12 6.33579 11.6642 6 11.25 6C10.8358 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.8358 7.5 11.25 7.5Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }